import { atom } from 'recoil';

export const ShowSuggestPlaceState = atom({
    key: 'ShowSuggestPlaceState', 
    default: false, 
});